// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


// Define a service using a base URL and expected endpoints
export const blogsApi = createApi({
    reducerPath: 'blogsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://jsonplaceholder.typicode.com/',
        // prepareHeaders: (headers) => {
        //     headers.set('app-id', '621bb51a44d71bc31fce2a9a')
        //     return headers
        // }
    }),

    endpoints: (builder) => ({
        getBlogs: builder.query({
            query: () => 'posts'
        }),
        getBlogsById: builder.query({
            query: (id) => `posts/${ id }`
        }),
        getImages: builder.query({
            query: () => 'photos'
        }),
    }),
})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBlogsQuery, useGetBlogsByIdQuery, useGetImagesQuery } = blogsApi